import React from "react";
import { Row, Col, Button, Form } from "react-bootstrap";
import Select from "react-select";
import { PermissionWrapper } from "../../PermissionWrapper/PermissionWrapper";

interface UsersFiltersProps {
  onAddUserClick?: () => void;
  statusValue: "" | "active" | "inactive";
  onStatusChange?: (value: "" | "active" | "inactive") => void;
  searchValue: string;
  onSearchChange?: (value: string) => void;
}

const UsersFilters: React.FC<UsersFiltersProps> = ({
  onAddUserClick,
  statusValue,
  onStatusChange,
  searchValue,
  onSearchChange,
}) => (
    <Row className="g-2 justify-content-md-end align-items-end flex-nowrap">
      <Col xs={12} md={5} className="min-w-0">
        <Form.Control
          type="search"
          placeholder="Search by name, email or contact number"
          autoComplete="new-password"
          name="accessManagementUsersSearch"
          spellCheck={false}
          value={searchValue}
          onChange={(e) => onSearchChange?.(e.target.value)}
        />
      </Col>
      <Col xs={6} md={2} className="flex-shrink-0">
        <Form.Label
          className="mb-1 text-muted"
          style={{ fontSize: 11 }}
        >
          Status
        </Form.Label>
        <Select
          classNamePrefix="react-select"
          options={[
            { value: "", label: "All" },
            { value: "active", label: "Active" },
            { value: "inactive", label: "Inactive" },
          ]}
          isClearable={false}
          value={
            [
              { value: "", label: "All" },
              { value: "active", label: "Active" },
              { value: "inactive", label: "Inactive" },
            ].find((opt) => opt.value === statusValue) ?? { value: "", label: "All" }
          }
          onChange={(option) =>
            onStatusChange?.((option?.value as "" | "active" | "inactive") ?? "")
          }
        />
      </Col>
      <Col
        xs={12}
        md="auto"
        className="flex-shrink-0 text-md-end d-flex align-items-stretch"
      >
        <PermissionWrapper
          anyOfPermissions={[
            "access_management.admin",
            "access_management.users.manage",
          ]}
          hideWhenDisabled
        >
          <Button
            variant="primary"
            className="w-100 d-flex align-items-center justify-content-center"
            style={{ height: 45 }}
            onClick={onAddUserClick}
          >
            Add User +
          </Button>
        </PermissionWrapper>
      </Col>
    </Row>
  );

export default UsersFilters;

